if (!customElements.get('product-listing')) {
  const plpLoader = `
    <div class="loader flex items-center justify-center !bg-transparent">
      <span class="block w-12 h-12">
        <svg class="animate-spin -ml-1 mr-3 h-full w-full text-accent1" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
      </span>
    </div>
  `;
  
  class ProductListing extends HTMLElement {
    constructor() {
      super();
      this.page = 1;
    }
    
    connectedCallback() {
      if (!this.isConnected) return;
      
      document.addEventListener('DOMContentLoaded', () => {
        const searchParams = new URL(window.location.href)?.searchParams;
        if (searchParams.get('page')) {
          const initialPage = Number(searchParams.get('page'));
          if (initialPage <= 1) return;
          
          for (let i = 2; i <= initialPage; i++) {
            this.paginate(i);
          }
        }
        
        const observer = new MutationObserver(() => {
          this.querySelectorAll('[data-pagination-wrapper]').forEach((wrapper) => {
            if (Number(wrapper.dataset.paginationWrapper) < Number(this.page)) {
              wrapper.remove();
            }
          });
        });

        observer.observe(this, {
          childList: true,
          subtree: true
        });

        this.closest('.shopify-section').style.setProperty('--col-span', 'unset');
        this.insertAdjacentHTML("beforeend", `
          <style>
            @media(max-width: 768px) {
              [data-product-tile] {
                grid-column: var(--col-span);
              }
            }
          </style>
        `);
      });
      
      ['change', 'click'].forEach((eventType) => {
        window.addEventListener(eventType, e => {
          const actionEl = e.target.closest('[data-filter-action]');
          if (!actionEl) return;
          
          const {
            filterAction,
            page,
            quickFilter
          } = actionEl.dataset;
          switch (filterAction) {
            case 'pagination-next':
              this.paginate(page);
            break;
            case '2 column':
                this.closest('.shopify-section').style.setProperty('--col-span', 'unset');
            break;
            case 'Single column':
                this.closest('.shopify-section').style.setProperty('--col-span', '1 /  span 2');
            break;
            case 'show-cash-price':
              sessionStorage.removeItem("showAsPoints");
              document.documentElement.style.setProperty('--cash-price-display', 'block');
              document.documentElement.style.setProperty('--cash-points-display', 'none');
            break;
            case 'show-points-price':
              sessionStorage.setItem("showAsPoints", true);
              document.documentElement.style.setProperty('--cash-price-display', 'none');
              document.documentElement.style.setProperty('--cash-points-display', 'block');
            break;
            case 'quick-filter':
              history.pushState({}, null, `${window.location.pathname}?${quickFilter}`);
              const drawer = document.querySelector('filter-drawer');
              drawer.fetchFilteredResults()
            break;
            default: break;
          }
        });
      });
    }
    
    paginate(page) {          
      const productContainer = this.querySelector('[data-product-container]');
      if (!productContainer) return;
      this.querySelector(`[data-pagination-wrapper="${page}"]`)?.remove();

      const searchParams = new URL(window.location.href)?.searchParams;
      searchParams.set('page', page);
      const newURL = `${window.location.origin}${window.location.pathname}?${searchParams.toString()}`;
      window.history.replaceState({}, 'Paginate', newURL);
      this.page = page;

      productContainer.insertAdjacentHTML('beforeend', `
        <intersection-loader 
          data-url="${newURL}"
          data-section-id="product-listing-grid"
          class="block w-full py-16 col-span-2 lg:col-span-3 2xl:col-span-4 loading relative"
        >${plpLoader}</intersection-loader>
      `);
    }
  }
  
  customElements.define('product-listing', ProductListing);
}